import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { EsnEmptyStateVariant } from '../../../shared/types/shell';
import { AccentHexagonComponent } from '../../atoms/accent-hexagon/accent-hexagon.component';

/**
 * What a list shows when it has no rows: `empty` invites the user to create the first item;
 * `no-results` explains that the filter is hiding rows and is announced to screen readers.
 * The action (Create / Clear filters) is projected.
 */
@Component({
  selector: 'esn-empty-state',
  imports: [AccentHexagonComponent],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.data-variant]': 'variant()',
    '[attr.role]': 'variant() === "no-results" ? "status" : null',
  },
})
export class EmptyStateComponent {
  readonly variant = input<EsnEmptyStateVariant>('empty');
  readonly title = input.required<string>();
  readonly text = input<string | null>(null);
}
